<div class="widgets-overlay" data-cy="widgets-overlay">
    <div class="widgets-overlay-modal widgets-overlay-modal-{{ type }} d-flex" style="align-items: center;">
        <div class="widgets-overlay-modal__child">
            <i class="{{ getIcon() }}"></i> <br />{{ getMessage() | translate }}
        </div>
    </div>
</div>
